module.exports = __webpack_public_path__ + "static/media/Nota Regreso a clases con Conservas con Semillas.ccba5f08.jpg";